module.exports = __webpack_public_path__ + "static/media/uploadIcon.43a410aa.svg";